import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";
import { IUpdateContractorRequestBody } from "./updateContractor.jsonschema";

export const updateContractor = (axios: IAxiosInstance) => {
  return async (body: IUpdateContractorRequestBody) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/updateContractorResponse"]
    >(`/api/updateContractor`, body);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
